import './style.scss';

import PropTypes from 'prop-types';
import ReactRouterPrompt from 'react-router-prompt';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { TextareaInput, CurrencyInput } from 'components/FormControl';

import AdjustmentForm from './AdjustmentForm';

function Form({
  errors,
  control,
  footerConfirmationPrompt,
  isDirty,
  dirtyFields,
  watch,
  setValue,
  readOnly,
}) {
  // #region Data
  const { t } = useTranslation();
  // #endregion

  return (
    <div>
      <div className="px-5 pb-2">
        <div className="flex mt-2 mb-4 justify-content-between align-items-center">
          <h4>Điều chỉnh kinh phí: </h4>
          <p className="text-right ">{t('financialAdjustment.unit')}</p>
        </div>
        <AdjustmentForm
          watch={watch}
          control={control}
          errors={errors}
          readOnly={readOnly}
          setValue={setValue}
        />
        <div className="grid p-fluid mt-2">
          <div className="col-12">
            <div className="col-3 p-0">
              <CurrencyInput
                label="Vốn khác"
                name="otherExpenditure"
                control={control}
                errors={errors}
              />
            </div>

            <div className="col-6 p-0">
              <h4>Cam kết</h4>
              <TextareaInput
                name="commitment"
                control={control}
                errors={errors}
                readOnly={readOnly}
                row={3}
              />
            </div>
          </div>
        </div>
      </div>

      {!readOnly && (
        <ReactRouterPrompt when={isDirty && Object.keys(dirtyFields)}>
          {({ isActive, onConfirm, onCancel }) => (
            <Dialog
              visible={isActive}
              header={<p className="text-blue-500">{t('projectProposal.confirmationTitle')}</p>}
              position="center"
              style={{ width: '300px' }}
              onHide={onCancel}
              draggable={false}
              footer={() => footerConfirmationPrompt(onConfirm, onCancel)}
            >
              <p className="text-lg py-3">{t('projectProposal.confirmationPromptMessage')}</p>
            </Dialog>
          )}
        </ReactRouterPrompt>
      )}
    </div>
  );
}

Form.propTypes = {
  errors: PropTypes.shape({}).isRequired,
  control: PropTypes.shape({}).isRequired,
  footerConfirmationPrompt: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  dirtyFields: PropTypes.object,
  isDirty: PropTypes.bool,
  readOnly: PropTypes.bool,
  watch: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
};

Form.defaultProps = {
  dirtyFields: {},
  isDirty: false,
  readOnly: false,
  footerConfirmationPrompt: () => null,
};

export default Form;
